<div class="row">
    <!-- label -->
    <div [class]="labelColCss">
        <label for="DiscoveredPSPVia" class="step-text" >
            <span [innerHTML]="'ReviewHow_2' | translator:'base'">How did you learn about PSP?</span>
            <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
            <hr>
        </label>
    </div>
    <div [class]="inputColCss">
        <!-- Discovered PSP Via dropdown -->
        <div class="psp-marketing-dropdown mb-3">
            <select [(ngModel)]="selectedItem" name="Discovered PSP Via" id="DiscoveredPSPVia"
                [ngClass]="{ 'form-select': true, 'bg-light': true }" (change)="onSelect($event)">
                <option *ngFor="let source of marketingSources; let index = index" [ngValue]="source">
                    {{ getSourceDisplay(source) }}
                </option>
            </select>
        </div>
        <!-- Discovered PSP Via sub dropdown -->
        <div class="psp-marketing-sub-dropdown" *ngIf="showDetailSelect">
            <div class="dropdown mb-3 position-relative">
                <!-- Filterable input field -->
                <input *ngIf="selectedItem?.details?.length > 0" 
                       type="text" 
                       [(ngModel)]="filterText" 
                       (input)="onFilterTextChange()"
                       (focus)="onFilterInputFocus()"
                       (blur)="onFilterInputBlur()"
                       (keydown)="onFilterKeydown($event)"
                       class="form-control bg-light"
                       placeholder="Type to filter options..."
                       aria-label="Filter and select PSP sub option"
                       autocomplete="off">
                
                <!-- Custom dropdown list -->
                <div *ngIf="showDropdown && filteredDetails.length > 0" 
                     class="dropdown-menu show w-100 position-absolute"
                     style="z-index: 1000; max-height: 200px; overflow-y: auto;">
                    <button *ngFor="let detail of filteredDetails; let index = index" 
                            type="button"
                            class="dropdown-item"
                            (click)="selectFilteredItem(detail)"
                            [class.active]="detail === subSelectedItem"
                            [class.highlighted]="index === selectedIndex">
                        <div class="psp-text">
                            {{getDetailDisplay(detail)}}
                        </div>
                    </button>
                </div>
            </div>
            <!-- show input if isCustomText is true -->
            <input *ngIf="subSelectedItem && subSelectedItem.isCustomText" type="text" id="customTextEntry"
                name="customTextEntry" [placeholder]="'PleaseDescribe' | translator:'base'"
                [ngClass]="{ 'form-control': true, 'bg-light': true, 'w-100': true }" [(ngModel)]="otherText"
                (change)="textChanged($event)" maxlength="128" pattern="[\-a-zA-Z0-9 '.,&amp;\(\)]+" />
        </div>
    </div>

    <input type="text" hidden [(ngModel)]="value" />
    <div class="psuedo-hidden" [innerHtml]="translate('Voodoo')">Voodoo!!! DO NOT CHANGE TO display:none or translation
        won't be triggered and grid language will not change on language drop down change.</div>

</div>